import React from 'react'

export default function Apoderado (props) {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path data-name="Rectángulo 3321" fill="none" d="M0 0h24v24H0z"/><path data-name="Trazado 13394" d="M14 2H6a2 2 0 00-1.99 2L4 20a2 2 0 001.99 2H18a2.006 2.006 0 002-2V8zm1 10h-4v1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1v1h-2v-1H9v-2h4v-1h-3a1 1 0 01-1-1v-3a1 1 0 011-1h1V9h2v1h2zm-2-4V3.5L17.5 8z" fill={props.fill}/></svg>
    )
}
 
